<template lang="pug">
  .component-selectize-driver
    selectize(ref="selectize", v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Reservation Rates")
</template>

<script>
import Selectize from '../../../Selectize'
import BaseSelectize from './BaseSelectize'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import {mapState} from 'vuex'

export default {
  name: 'SelectizeReservationRate',
  extends: BaseSelectize,
  components: {Selectize},
  data() {

    return {
      searchableFields: ['id', 'name']
    }
  },
  created() {
    KeplerBackofficeSdk.reservationRates.list.rates((data) => {
      this.options = data
    })
  },
  methods: {
    optionTemplate(item, escape) {
      return `<div>
                <div><small>RR${item.id}</small></div>
                <div>${item.name}</div>
                </div>`
    },
    renderTemplate(item, escape) {
      return `<div>${item.name}</div>`
    }
  },
  props: ['selectedValue'],
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    currency() {
      return this.configuration.commercial.commercial_currency.value
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeReservationRate.vue?5b25c9f0